import { render, staticRenderFns } from "./DevAudit.vue?vue&type=template&id=4b4bc85a&scoped=true&"
import script from "./DevAudit.vue?vue&type=script&lang=ts&"
export * from "./DevAudit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4bc85a",
  null
  
)

export default component.exports